import { ActionButtonProps, Box, ColorOptions, Form, IconButton, ModBox, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { EmType } from '../../..'
import { useStores } from '../../../../../data/store'
import { contactDetailsForm } from './formData'

interface ContactItemProps {
  index: number
  isEditMode: boolean
  onDeletePress: (index: number) => void
  onDataChange: (index: number, key: string, value: string) => void
  isValidToProceed: (index: number, isValid: boolean) => void
  data: any
  emsType: string
  allowNotification: string
  dummyValue: string
  dataLength: number
}

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}

const ContactItem = ({
  index,
  isEditMode,
  onDeletePress,
  onDataChange,
  isValidToProceed,
  data,
  emsType,
  allowNotification,
  dummyValue,
  dataLength,
}: ContactItemProps) => {
  const { getLovsFromKey, isUniqueContactNumber, getLovsDescriptionFromKeyValue } = useStores((store) => ({
    addContactProfile: store.onboarding.addContactProfile,
    getLovsFromKey: store.getLovsFromKey,
    isUniqueContactNumber: store.onboarding.checkIsUniqueContactNumber,
    getLovsDescriptionFromKeyValue: store?.getLovsDescriptionFromKeyValue,
  }))
  const [typedData, setTypedData] = useState<any>({})
  const [mobileError, setMobileError] = useState('')

  useEffect(() => {
    if (data) {
      setTypedData(data)
    }
  }, [data])

  const onDelete = () => {
    onDeletePress && onDeletePress(index)
  }

  const onChangeData = (key: string, value: string) => {
    onDataChange(index, key, value)
  }

  const actionButtons = ({ values, isCurrentFormValid = false }: ActionButtonProps) => {
    let isUniqueMobile = true
    Object.keys(values).map((key) => {
      if (values[key] !== typedData[key]) {
        if (key === 'mobileNumber') {
          isUniqueMobile = isUniqueContactNumber(index, key, values[key])
          isUniqueMobile
            ? !isNaN(values[key]) && values[key]?.length !== 10
              ? setMobileError('Mobile number must be 10 digits')
              : setMobileError('')
            : setMobileError('Mobile Number should be unique')
        }
        onChangeData(key, values[key])
      }
    })
    isValidToProceed && isValidToProceed(index, isCurrentFormValid && isUniqueMobile)
  }
  console.log('===> Contact fName, lName, dummyValue: ', data?.firstName, data?.lastName, dummyValue)

  return (
    <Box w={'100%'} marginVertical={16}>
      <Box direction="row" justifyContent={'space-between'} w={'100%'} marginTop={8}>
        <ModBox marginRight={16} marginTop={8}>
          <Text title={`Contact Profile ${index + 1}`} fontFamily="jiotype-bold" fontSize={14} />
        </ModBox>
        <ModBox alignItems={'center'} w="80%" justifyContent={'center'}>
          <Box borderStyle={'dashed'} borderColor={'BORDER_COLOR'} borderWidth={1} w={'100%'} />
        </ModBox>
        <ModBox
          show={index > 0 && emsType !== EmType.Search && isEditMode && index === dataLength - 1}
          h={32}
          w={32}
          borderWidth={1}
          borderRadius={4}
          borderColor={'#E0E0E0' as ColorOptions}>
          <IconButton color={'BLACK_21'} id="DELETE" size={16} onPress={onDelete} />
        </ModBox>
        <ModBox show={!(index > 0 && emsType !== EmType.Search && isEditMode)} h={32} w={32} />
      </Box>
      <ModBox marginTop={32}>
        <Form
          allTouched={emsType === EmType.Search && isEditMode}
          formData={contactDetailsForm(
            isEditMode,
            getLovsFromKey,
            (emsType === EmType.Search && data?.type === 'GROUP') ||
              emsType === EmType.createGroup ||
              (emsType === EmType.applicationQueue && data?.groupContactNotification),
            index,
            allowNotification,
            mobileError,
          )}
          actionButtons={actionButtons}
          initialValues={{
            mobileNumber: isEditMode
              ? typedData?.mobileNumber
              : !isEmpty(data?.mobileNumber)
              ? `${data?.mobileNumber}`
              : 'NA',
            firstName: isEditMode ? typedData?.firstName : !isEmpty(data?.firstName) ? data?.firstName : 'NA',
            lastName: isEditMode ? typedData?.lastName : !isEmpty(data?.lastName) ? data?.lastName : 'NA',
            dob: isEditMode
              ? typedData?.dob ?? typedData?.dateOfBirth
              : !isEmpty(data?.dateOfBirth)
              ? data?.dateOfBirth
              : 'NA',
            gender: isEditMode
              ? !isEmpty(typedData?.gender)
                ? getLovsDescriptionFromKeyValue('Gender', typedData?.gender)
                : ''
              : !isEmpty(data?.gender)
              ? getLovsDescriptionFromKeyValue('Gender', data?.gender)
              : 'NA',
            emailId: isEditMode ? typedData?.emailId : !isEmpty(data?.emailId) ? data?.emailId : 'NA',
            phone1: isEditMode
              ? !isEmpty(typedData?.landlineNumber) && typedData?.landlineNumber !== 'NA'
                ? typedData?.landlineNumber
                : !isEmpty(typedData?.phone1) && typedData?.phone1 !== 'NA'
                ? typedData?.phone1
                : ''
              : !isEmpty(data?.phone1)
              ? data?.phone1
              : !isEmpty(data?.landlineNumber)
              ? data?.landlineNumber
              : 'NA',
            addressLine1: isEditMode
              ? !isEmpty(typedData?.entityContactAddress?.addressLine1) &&
                typedData?.entityContactAddress?.addressLine1 !== 'NA'
                ? typedData?.entityContactAddress?.addressLine1
                : !isEmpty(typedData?.address1) && typedData?.address1 !== 'NA'
                ? typedData?.address1
                : !isEmpty(typedData?.addressLine1) && typedData?.addressLine1 !== 'NA'
                ? typedData?.addressLine1
                : ''
              : !isEmpty(data?.entityContactAddress?.addressLine1)
              ? data?.entityContactAddress?.addressLine1
              : !isEmpty(data?.groupContactAddress?.addressLine1)
              ? data?.groupContactAddress?.addressLine1
              : !isEmpty(data?.address1)
              ? data?.address1
              : 'NA',
            addressLine2: isEditMode
              ? !isEmpty(typedData?.entityContactAddress?.addressLine2) &&
                typedData?.entityContactAddress?.addressLine2 !== 'NA'
                ? typedData?.entityContactAddress?.addressLine2
                : !isEmpty(typedData?.address2) && typedData?.address2 !== 'NA'
                ? typedData?.address2
                : !isEmpty(typedData?.addressLine2) && typedData?.addressLine2 !== 'NA'
                ? typedData?.addressLine2
                : ''
              : !isEmpty(data?.entityContactAddress?.addressLine2)
              ? data?.entityContactAddress?.addressLine2
              : !isEmpty(data?.groupContactAddress?.addressLine2)
              ? data?.groupContactAddress?.addressLine2
              : !isEmpty(data?.address2)
              ? data?.address2
              : 'NA',
            city: isEditMode
              ? !isEmpty(typedData?.entityContactAddress?.city) && typedData?.entityContactAddress?.city !== 'NA'
                ? typedData?.entityContactAddress?.city
                : !isEmpty(typedData?.city) && typedData?.city !== 'NA'
                ? typedData?.city
                : ''
              : !isEmpty(data?.entityContactAddress?.city)
              ? data?.entityContactAddress?.city
              : !isEmpty(data?.groupContactAddress?.city)
              ? data?.groupContactAddress?.city
              : !isEmpty(data?.city)
              ? data?.city
              : 'NA',
            state: isEditMode
              ? !isEmpty(typedData?.entityContactAddress?.state) && typedData?.entityContactAddress?.state !== 'NA'
                ? getLovsDescriptionFromKeyValue('State', typedData?.entityContactAddress?.state)
                : !isEmpty(typedData?.state) && typedData?.state !== 'NA'
                ? getLovsDescriptionFromKeyValue('State', typedData?.state)
                : ''
              : !isEmpty(data?.entityContactAddress?.state)
              ? getLovsDescriptionFromKeyValue('State', data?.entityContactAddress?.state)
              : !isEmpty(data?.groupContactAddress?.state)
              ? getLovsDescriptionFromKeyValue('State', data?.groupContactAddress?.state)
              : !isEmpty(data?.state)
              ? getLovsDescriptionFromKeyValue('State', data?.state)
              : 'NA',
            pincode: isEditMode
              ? !isEmpty(typedData?.entityContactAddress?.pincode) && typedData?.entityContactAddress?.pincode !== 'NA'
                ? typedData?.entityContactAddress?.pincode
                : !isEmpty(typedData?.pincode) && typedData?.pincode !== 'NA'
                ? typedData?.pincode
                : ''
              : !isEmpty(data?.entityContactAddress?.pincode)
              ? data?.entityContactAddress?.pincode
              : !isEmpty(data?.groupContactAddress?.pincode)
              ? data?.groupContactAddress?.pincode
              : !isEmpty(data?.pincode)
              ? data?.pincode
              : 'NA',
            role: isEditMode ? `${typedData?.role ?? ''}` : !isEmpty(data?.role) ? data?.role : 'NA',
            allowNotification: !isEmpty(data?.allowNotification) ? data?.allowNotification : '',
            dummyHiddenViewCp: `${dummyValue}_${isEditMode}`,
          }}
          container={FormBox}
        />
      </ModBox>
    </Box>
  )
}

export { ContactItem }
